// extracted by mini-css-extract-plugin
export default {"page":"CY-z","cartModal":"DY-z","checkout":"EY-z","placeholder":"FY-z","account":"GY-z"};